import Users from './Users'
import Menu from './Menu'
import UserTypeGroup from './UserTypeGroup'
import IssueProblemManage from './IssueProblemManage'

export default {
  Users,
  Menu,
  UserTypeGroup,
  IssueProblemManage
}



// WEBPACK FOOTER //
// ./src/components/HRM/System/index.js